import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import LayoutTopFillIcon from 'remixicon-react/LayoutTopFillIcon'
// import QuestionLineIcon from 'remixicon-react/QuestionLineIcon'
import VideoLineIcon from 'remixicon-react/VideoLineIcon'
import XArrowIcon from '@UI/XArrowIcon'
import useMenu from '@hooks/component/useMenu'
import { IMenu } from '@utils/constants/menu'
import { NAVIGATION_POSTION } from '@utils/constants'
import { LOCALSTORAGE_KEYS } from '@features/General'
import { RootState } from '@store/store'
import MenuTooltip from './Tooltip'
import styles from './index.scss'

interface IProps {
    collapsed: boolean
    isOnMobile?: boolean
    onCollapsed?: () => void
    showUserGuide?: () => void
    showVideoGuide?: () => void
}

function SiderBarMenu(props: IProps) {
    const { collapsed, onCollapsed, showVideoGuide } = props
    const { menus } = useMenu()
    const { data: i18n } = useSelector((state: RootState) => state.localization.locals)

    return (
        <div className={styles.menu}>
            <div className={classNames(styles['menu-item'], styles['menu-item-collapsed'])} onClick={onCollapsed}>
                <XArrowIcon reverse={collapsed} />
            </div>

            <div className={styles['dynamic-menu']}>
                {menus
                    .filter(item => !item.hide && item.permission !== false)
                    .map((item: IMenu, index: number) => (
                        <Link to={item.path} key={index}>
                            <MenuTooltip title={item.title} icon={item.icon} path={item.path} collapsed={collapsed} />
                        </Link>
                    ))}
            </div>

            <MenuTooltip
                collapsed={collapsed}
                title={i18n.extraKeys?.Open_Guide_Video}
                icon={<VideoLineIcon size={22} />}
                onClick={showVideoGuide}
            />
            <div
                className={classNames(styles['menu-item'], {
                    [styles.collapsed]: !collapsed
                })}
                onClick={() => {
                    localStorage.setItem(LOCALSTORAGE_KEYS.NAVIGATION_POSTION, NAVIGATION_POSTION.TOP)
                    location.reload()
                }}
                title={collapsed ? i18n?.Dashboard?.Switch_Menu : ''}
            >
                <LayoutTopFillIcon size={20} />
                {!collapsed && <span>{i18n?.Dashboard?.Switch_Menu}</span>}
            </div>
            {/* <MenuTooltip
                collapsed={collapsed}
                title={i18n.extraKeys?.Open_Guide_Tour}
                icon={<QuestionLineIcon size={22} />}
                onClick={showUserGuide}
            /> */}
        </div>
    )
}
export default SiderBarMenu
